// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"s2-z","dimensionLabel":"t2-z","styleChooserControlWrapper":"u2-z","styleChooserControl":"v2-z","disabled":"w2-z","giftCard":"x2-z","styleChooserText":"y2-z"};